import React from "react";
import {Button} from "react-bootstrap";
import SVG from 'react-inlinesvg';

import avatar from '../../../assets/img/demo/player-avatar-7.png';
import deleteIcon from '../../../assets/svg/actions/icn-delete-24px-grey.svg';
import SimpleScrollbar from "../custom_scrollbars/SimpleScrollbar";

const Contact = (props) => {

    return (
        <div className="contact-wrapper">
            <SimpleScrollbar className="contact-scroll" maxHeight="calc(100vh - 165px)">

                <div className="contact-info">
                    <img src={avatar} alt="Player image"/>
                    <h2>Gregory Bell</h2>
                    <span>Scout | Canberry Football Club</span>
                    <p>Short bio if available Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.Esse excepteur proident tempor anim laborum sint et eiusmod id elit consesde.</p>
                    <Button variant="link" className="delete-contact">
                        <span>Delete Contact</span><SVG src={deleteIcon}></SVG>
                    </Button>
                </div>

                <div className="contact-detail date">
                    <label>Connected On</label>
                    <time>12/26/2019</time>
                </div>

                <div className="contact-request">
                    <Button variant="primary" className="btn-md">Start Chat</Button>
                </div>

            </SimpleScrollbar>
        </div>
    )
};

export default Contact;
